import { z } from 'zod'
import { VENUE_PAGE_NEEDS } from '../constants/venue-public-page.js'

/**
 * A venue's page on the public site, as Venue setup shows it
 * (docs/public-site.spec.md, "A venue's page").
 */
export const venuePublicPageSettingsDtoSchema = z.object({
  /** The switch, as staff left it. */
  on: z.boolean(),
  description: z.string().nullable(),
  website: z.string().nullable(),
  /** What the page still needs, in the order Venue setup lists it. Empty when complete. */
  missing: z.array(z.enum(VENUE_PAGE_NEEDS)),
  /**
   * Why a page that is on isn't showing: something it needs is missing, or the
   * company is locked for billing. Null when it shows, or is off.
   */
  hidden: z.enum(['missing', 'locked']).nullable(),
  /** `/venues/<name>` on the public site, once the page has ever been on. */
  path: z.string().nullable(),
  /** The page lists the venue's vendors that have pages of their own. Defaulted while an older API is still answering. */
  vendorsOn: z.boolean().default(false),
  /** How many of the vendors the venue works with have a page showing: the ones the list would show. */
  vendorsWithPages: z.number().int().nonnegative().default(0),
})

export type VenuePublicPageSettingsDto = z.infer<typeof venuePublicPageSettingsDtoSchema>
